<div class="markdown-editor-toolbar" role="toolbar" aria-label="Markdown formatting">
  <button mat-icon-button type="button" matTooltip="Bold" aria-label="Bold" [disabled]="isDisabled()" (click)="onBold()">
    <mat-icon aria-hidden="true">format_bold</mat-icon>
  </button>
  <button mat-icon-button type="button" matTooltip="Italic" aria-label="Italic" [disabled]="isDisabled()" (click)="onItalic()">
    <mat-icon aria-hidden="true">format_italic</mat-icon>
  </button>
  <button mat-icon-button type="button" matTooltip="Heading 1" aria-label="Heading 1" [disabled]="isDisabled()" (click)="onHeading(1)">
    <span class="toolbar-text">H1</span>
  </button>
  <button mat-icon-button type="button" matTooltip="Heading 2" aria-label="Heading 2" [disabled]="isDisabled()" (click)="onHeading(2)">
    <span class="toolbar-text">H2</span>
  </button>
  <button mat-icon-button type="button" matTooltip="Heading 3" aria-label="Heading 3" [disabled]="isDisabled()" (click)="onHeading(3)">
    <span class="toolbar-text">H3</span>
  </button>
  <button mat-icon-button type="button" matTooltip="Link" aria-label="Link" [disabled]="isDisabled()" (click)="onLink()">
    <mat-icon aria-hidden="true">link</mat-icon>
  </button>
  <button mat-icon-button type="button" matTooltip="Image" aria-label="Image" [disabled]="isDisabled()" (click)="onImage()">
    <mat-icon aria-hidden="true">image</mat-icon>
  </button>
  <button mat-icon-button type="button" matTooltip="Bullet list" aria-label="Bullet list" [disabled]="isDisabled()" (click)="onBulletList()">
    <mat-icon aria-hidden="true">format_list_bulleted</mat-icon>
  </button>
  <button mat-icon-button type="button" matTooltip="Numbered list" aria-label="Numbered list" [disabled]="isDisabled()" (click)="onNumberedList()">
    <mat-icon aria-hidden="true">format_list_numbered</mat-icon>
  </button>
  <button mat-icon-button type="button" matTooltip="Code block" aria-label="Code block" [disabled]="isDisabled()" (click)="onCodeBlock()">
    <mat-icon aria-hidden="true">code</mat-icon>
  </button>
  <span class="toolbar-spacer"></span>
  <button mat-icon-button type="button" matTooltip="Toggle preview" aria-label="Toggle preview" [disabled]="isDisabled()" (click)="togglePreview()">
    <mat-icon aria-hidden="true">{{ showPreview() ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
</div>

<div #editorHost class="codemirror-host"></div>

@if (showPreview()) {
  <div class="markdown-preview" role="region" aria-label="Markdown preview">
    <markdown [data]="content()"></markdown>
  </div>
}
